"use strict";

document.addEventListener("DOMContentLoaded", () => {
  if (customElements.get("unique-selling-point")) return;
  customElements.define("unique-selling-point", class extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.interval = null;
      this.fadeInterval = (Number.parseInt(this.getAttribute("data-fade-interval")) || 5) * 1000;
      this.fadeDuration = Number.parseInt(this.getAttribute("data-fade-duration")) || 800;
      this.enableMobile = this.getAttribute("data-enable-mobile") === "true";
      this.enableDesktop = this.getAttribute("data-enable-desktop") === "true";
      this.mediaQuery = window.matchMedia("(max-width: 1024px)");
      this.items = null;
      this.container = null;
    }
    connectedCallback() {
      this.items = [...this.querySelectorAll(".ss25_usp__item")];
      this.container = this.querySelector(".ss25_usp");
      this.updateState = this.updateState.bind(this);
      this.debouncedResize = this.debouncedResize.bind(this);
      this.mediaQuery.addEventListener("change", this.updateState);
      window.addEventListener("resize", this.debouncedResize);
      this.checkPositionValidity();
      this.updateState();
      this.scheduleUspHeight();
    }
    disconnectedCallback() {
      this.cleanup();
      this.mediaQuery.removeEventListener("change", this.updateState);
      window.removeEventListener("resize", this.debouncedResize);
    }
    updateState() {
      const isMobile = this.mediaQuery.matches;
      const shouldRun = isMobile && this.enableMobile || !isMobile && this.enableDesktop;
      if (shouldRun) {
        this.init();
      } else {
        this.cleanup();
        this.scheduleUspHeight();
      }
    }
    scheduleUspHeight() {
      if (!this.isInValidPosition) {
        return;
      }
      setTimeout(() => this.calculateUspHeight(), 100);
    }
    cleanup() {
      if (!this.interval) {
        return;
      }
      clearInterval(this.interval);
      this.interval = null;
      this.items.forEach((item, index) => {
        const animCount = item.getAnimations().length;
        item.getAnimations().forEach(anim => anim.cancel());
        item.removeAttribute("style");
      });
      this.container?.removeAttribute("style");
      this.scheduleUspHeight();
    }
    init() {
      if (this.interval) {
        return;
      }
      if (this.items.length <= 1) {
        return;
      }
      const style = window.getComputedStyle(this.container);
      const verticalPadding = parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
      const maxHeight = Math.max(...this.items.map((item, index) => {
        const prevDisplay = item.style.display;
        item.style.display = "block";
        const height = item.offsetHeight;
        item.style.display = prevDisplay;
        return height;
      }));
      const containerHeight = maxHeight + verticalPadding;
      this.container.style.height = `${containerHeight}px`;
      const baseStyles = {
        position: "absolute",
        top: style.paddingTop,
        left: "0",
        width: "100%"
      };
      this.items.forEach((item, i) => {
        Object.assign(item.style, {
          ...baseStyles,
          opacity: i === 0 ? "1" : "0",
          zIndex: i === 0 ? "2" : "1"
        });
      });
      this.interval = setInterval(() => requestAnimationFrame(() => this.rotate()), this.fadeInterval);
      this.scheduleUspHeight();
    }
    rotate() {
      const prev = this.items[this.currentIndex];
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      const next = this.items[this.currentIndex];
      const fadeOut = {
          opacity: 1
        },
        fadeIn = {
          opacity: 0
        };
      const options = {
        duration: this.fadeDuration,
        fill: "forwards"
      };
      prev.animate([fadeOut, fadeIn], options).onfinish = () => {
        prev.style.zIndex = "1";
        next.style.zIndex = "2";
        next.animate([fadeIn, fadeOut], options);
      };
    }
    debouncedResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        if (this.interval) {
          this.cleanup();
        }
        this.updateState();
        this.scheduleUspHeight();
      }, 200);
    }
    checkPositionValidity() {
      const thisUspSection = this.closest(".section-ss25_usp");
      if (!thisUspSection) {
        this.isInValidPosition = false;
        return;
      }
      const prevSection = thisUspSection.previousElementSibling;
      const isValidHero = prevSection && (prevSection.classList.contains("section-ss25_slideshow") || prevSection.classList.contains("section-ss25_media-banner")) && prevSection === thisUspSection.parentElement?.firstElementChild;
      this.isInValidPosition = isValidHero;
    }
    calculateUspHeight() {
      if (!this.isInValidPosition) {
        return;
      }
      const thisUspSection = this.closest(".section-ss25_usp");
      const uspList = thisUspSection?.querySelector("ul.ss25_usp");
      if (uspList) {
        const totalHeight = uspList.offsetHeight;
        document.documentElement.style.setProperty("--hero-usp-height", `${totalHeight}px`);
        document.documentElement.classList.add("ss25-hero-usp-height-calculated");
      } else {}
    }
  });
});